import React from "react";
import { API_URL } from "../../redux/constants/type";
import { axiosInstance } from "../../redux/constants/axiosInstance";

const getOutlookReturnUrl = () => {
  const returnUrl = new URL(
    `${window.location.pathname}${window.location.search}`,
    window.location.origin,
  );

  returnUrl.searchParams.delete("status");
  returnUrl.searchParams.delete("provider");

  return returnUrl.toString();
};

export const outlookLogin = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/api/Integration/Outlook/Connect`,
      {
        params: { ReturnUrl: getOutlookReturnUrl() },
      },
    );

    const redirectUrl =
      response?.data?.data?.authorizationUrl ||
      response?.data?.authorizationUrl ||
      (typeof response?.data === "string" ? response.data : "");

    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  } catch (error) {
    console.error("Outlook connect failed:", error);
  }
};

export const OutlookAuthBtn = ({ handleRefresh }) => {
  return <button type="button" onClick={outlookLogin} />;
};
